export enum TAGS_COLORS {
    OCEAN = 'ocean',
    DENIM = 'tone-blue',
    LYCHEE = 'tone-maroon'
}

export const LIFE_CYCLE_TAGS = {
    just_added: 'Just added',
    under_offer: 'Under offer',
    sold_subject_to_contract: 'Sold subject to contract',
    let_agreed: 'Let agreed',
    let: 'Let',
    equity_loan: 'Equity loan',
    new_build: 'New build',
    new_home: 'New home',
    part_buy_part_rent: 'Part buy part rent',
    shared_equity: 'Shared equity',
    shared_ownership: 'Shared ownership',
    student_friendly: 'Student friendly',
    investment: 'Investment'
};
